(() => {
  function initialize(root) {
    if (root.dataset.summitReady) return;
    root.dataset.summitReady = 'true';
    const header = root.closest('header');
    const launcher = header.querySelector('#navToggle');
    const desktop = window.matchMedia('(min-width: 992px)');
    const entries = Array.from(root.querySelectorAll('.summit-submenu-toggle')).map(button => ({
      button,
      item: button.parentElement,
      panel: document.getElementById(button.getAttribute('aria-controls'))
    })).filter(entry => entry.panel);

    function setOpen(entry, open) {
      entry.button.setAttribute('aria-expanded', String(open));
      entry.item.classList.toggle('summit-submenu-open', open);
      entry.panel.hidden = !open;
    }

    function closeAll(except) {
      entries.forEach(entry => {
        if (entry !== except) setOpen(entry, false);
      });
    }

    function setMobile(open) {
      root.dataset.mobileOpen = String(open);
      launcher.setAttribute('aria-expanded', String(open));
      launcher.classList.toggle('active', open);
      if (!open) closeAll();
    }

    setMobile(false);
    entries.forEach(entry => {
      setOpen(entry, false);
      entry.item.addEventListener('pointerenter', event => {
        if (!desktop.matches || event.pointerType !== 'mouse') return;
        closeAll(entry);
        setOpen(entry, true);
      });
      entry.item.addEventListener('pointerleave', () => {
        if (desktop.matches && !entry.item.contains(document.activeElement)) setOpen(entry, false);
      });
      entry.item.addEventListener('focusout', event => {
        if (desktop.matches && !entry.item.contains(event.relatedTarget)) setOpen(entry, false);
      });
      entry.item.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !entry.panel.hidden) {
          event.preventDefault();
          event.stopPropagation();
          setOpen(entry, false);
          entry.button.focus();
        } else if (event.key === 'ArrowDown' && (event.target === entry.button || event.target === entry.item.querySelector(':scope > a'))) {
          event.preventDefault();
          closeAll(entry);
          setOpen(entry, true);
          entry.panel.querySelector('a[href]')?.focus();
        }
      });
      entry.panel.querySelectorAll('a[href]').forEach(link => {
        if (new URL(link.href).pathname === window.location.pathname) link.setAttribute('aria-current', 'page');
      });
    });

    header.addEventListener('click', event => {
      const button = event.target.closest('.summit-submenu-toggle');
      const entry = entries.find(candidate => candidate.button === button);
      if (entry) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const open = entry.panel.hidden;
        closeAll(entry);
        setOpen(entry, open);
      } else if (event.target.closest('#navToggle') === launcher) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setMobile(launcher.getAttribute('aria-expanded') !== 'true');
      }
    }, true);

    header.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !desktop.matches && launcher.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setMobile(false);
        launcher.focus();
      }
    });
    header.addEventListener('focusout', event => {
      if (!header.contains(event.relatedTarget)) setMobile(false);
    });
    document.addEventListener('pointerdown', event => {
      if (!header.contains(event.target)) setMobile(false);
    });
    desktop.addEventListener('change', () => setMobile(false));
  }

  function initializeAll() {
    document.querySelectorAll('[data-summit-navigation]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
